import React, { useState, useEffect } from 'react'; 
import { Button, Row, Col, Pagination, notification } from 'antd';
import axios from 'axios';
import './NumberSelector.css';

const NumberSelector = ({ onSelectNumber, cart }) => {
  const [purchasedNumbers, setPurchasedNumbers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Página actual
  const itemsPerPage = 100;

  // Cargar los números comprados desde la API al montar el componente
  useEffect(() => {
    const fetchPurchasedNumbers = async () => {
      try {
        const response = await axios.get('https://appmagdalena.net/api/lottery/numbers/all');
        if (response.data.success) {
          const numbers = response.data.data.jornadas.map((item) => item.number); // Extraemos los números
          setPurchasedNumbers(numbers); // Guardamos los números comprados
        } else {
          notification.error({
            message: 'Error al cargar los números',
            description: 'No se pudieron cargar los números comprados.',
          });
        }
      } catch (error) {
        notification.error({
          message: 'Error de conexión',
          description: 'Hubo un problema al conectar con la API.',
        });
      }
    };

    fetchPurchasedNumbers();
  }, []);

  // Generar la lista de números (del 000 al 999) y filtrar los que ya han sido comprados
  const totalNumbers = Array.from({ length: 1000 }, (_, i) => String(i).padStart(3, '0')); // Números del 000 al 999
  const availableNumbers = totalNumbers.filter((number) => !purchasedNumbers.includes(number));

  // Calculamos los números que se deben mostrar en la página actual
  const indexOfLastNumber = currentPage * itemsPerPage;
  const indexOfFirstNumber = indexOfLastNumber - itemsPerPage;
  const currentNumbers = availableNumbers.slice(indexOfFirstNumber, indexOfLastNumber);

  // Función para cambiar la página
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Función para manejar la selección de números
  const handleClick = (number) => {
    if (!cart.includes(number)) {
      onSelectNumber(number);
    }
  };

  return (
    <div className="number-selector" style={{ marginBottom: '20px' }}>
      {/* Mostramos los números disponibles */}
      <Row gutter={[16, 16]} justify="center">
        {currentNumbers.map((number) => (
          <Col xs={6} sm={4} md={3} lg={2} key={number}>
            <Button
              type="primary"
              onClick={() => handleClick(number)}
              disabled={cart.includes(number) || purchasedNumbers.includes(number)} // Desactivamos los números comprados
              block
              style={{ fontSize: '16px', padding: '10px' }}
            >
              {number}
            </Button>
          </Col>
        ))}
      </Row>

      {/* Paginación */}
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <Pagination
          current={currentPage}
          total={availableNumbers.length}  // Paginamos solo los números disponibles
          pageSize={itemsPerPage}
          onChange={handlePageChange}
          showSizeChanger={false} // Oculta el cambio de tamaño de página
        />
      </div>
    </div>
  );
};

export default NumberSelector;
